/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display.Align.To
 */

module.exports = {

    BottomCenter: require('./BottomCenter'),
    BottomLeft: require('./BottomLeft'),
    BottomRight: require('./BottomRight'),
    LeftBottom: require('./LeftBottom'),
    LeftCenter: require('./LeftCenter'),
    LeftTop: require('./LeftTop'),
    RightBottom: require('./RightBottom'),
    RightCenter: require('./RightCenter'),
    RightTop: require('./RightTop'),
    TopCenter: require('./TopCenter'),
    TopLeft: require('./TopLeft'),
    TopRight: require('./TopRight')

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/display/align/to/index.js
// module id = 1503
// module chunks = 0